<template>
  <v-card height="100%">
    <v-card-title primary-title>
      Ejemplo
    </v-card-title>
    <v-card-text>
      <div>
        <v-list two-line>
          <v-list-item-group v-model="selected" multiple>
            <template v-for="(item, index) in items">
              <v-list-item :key="`item.title-${index}`">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle
                      v-if="item.subtitle"
                      class="text--primary"
                      v-text="item.subtitle"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="item.helperText"
                      v-text="item.helperText"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-subtitle
                      class="text--primary"
                      v-text="item.value"
                    ></v-list-item-subtitle>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < items.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
const FORMATTER = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  maximumFractionDigits: 0
});
export default {
  name: "ExamplePricingRules",
  data() {
    return {
      pricePropertie: 1000000,
      iva: 18,
      selected: [0]
    };
  },
  props: {
    pricingRules: Object,
    listDiscounts: { type: Array, default: () => [] },
    realEstateDiscount: { type: Array, default: () => [] }
  },
  computed: {
    finalPrice() {
      return this.priceIVa - this.discountTotal;
    },
    finalPriceSIva() {
      return this.priceSIVa - this.fixedDiscount(this.priceSIVa);
    },
    priceSIVa() {
      return this.pricePropertie;
    },
    priceIVa() {
      return this.pricePropertie * (this.iva / 100 + 1);
    },
    terminationPayment() {
      return this.calculate(this.pricingRules.termination_payment);
    },
    items() {
      return [
        {
          value: this.formatPrice(this.pricePropertie),
          title: "Precio de la unidad"
        },
        {
          value: this.formatPrice(this.priceSIVa),
          title: "Precio sin IVA"
        },
        {
          value: this.formatPrice(this.priceIVa),
          title: "Precio con IVA (Ej. 18%)"
        },
        {
          value: this.formatPrice(this.guaranteeDeposit.value),
          subtitle:
            this.pricingRules.guarantee_deposit.type === "percentage"
              ? `Se calcula el porcentaje (${this.pricingRules.guarantee_deposit.amount}%)`
              : "Es un monto fijo",
          title: "Apartado"
        },
        {
          value: this.formatPrice(this.percentageDownPayment.value),
          subtitle:
            this.pricingRules.percentage_down_payment.type === "percentage"
              ? `Se calcula el porcentaje (${this.pricingRules.percentage_down_payment.amount}%)`
              : "Es un monto fijo",
          title: "Enganche"
        },
        {
          value: this.formatPrice(
            this.pricingRules.financing_auto
              ? this.generateFinancingAuto()
              : this.financing.value
          ),
          subtitle: this.pricingRules.financing_auto
            ? "Se genera automaticamente"
            : this.pricingRules.financing.type === "percentage"
            ? `Se calcula el porcentaje (${this.pricingRules.financing.amount}%)`
            : "Monto fijo",
          helperText: this.pricingRules.financing_interest
            ? `El interés se desglosa en el cotizador (${this.pricingRules.financing_interest}%)`
            : "",
          title: "Financiamiento"
        },
        {
          title: "Finiquito",
          value: this.formatPrice(this.terminationPayment.value),
          subtitle:
            this.pricingRules.termination_payment.type === "percentage"
              ? `Se calcula el porcentaje (${this.pricingRules.termination_payment.amount}%)`
              : "Es un monto fijo"
        },
        ...this.discountsSelected.map(item => {
          return this.generateItemDiscount(item);
        }),
        {
          value: this.formatPrice(this.discountTotal),
          title: "Descuento total",
          subtitle: "Con IVA"
        },
        {
          value: this.formatPrice(this.fixedDiscount(this.priceSIVa)),
          title: "Descuento total",
          subtitle: "Sin IVA"
        },
        {
          value: this.formatPrice(this.finalPriceSIva),
          title: "Precio final sin IVA"
        },
        {
          value: this.formatPrice(this.finalPrice),
          title: "Precio final con IVA"
        }
      ];
    },
    discountsSelected() {
      return this.realEstateDiscount.filter(item =>
        this.pricingRules.discounts.includes(item._id)
      );
    },
    discountTotal() {
      return this.fixedDiscount(this.priceIVa);
    },
    guaranteeDeposit() {
      return this.calculate(this.pricingRules.guarantee_deposit);
    },
    percentageDownPayment() {
      return this.calculate(this.pricingRules.percentage_down_payment);
    },
    financing() {
      return this.calculate(this.pricingRules.financing);
    }
  },
  methods: {
    fixedDiscount(price) {
      let amount = 0;

      if (this.discountsSelected) {
        amount += this.calculateDiscountPro(price, this.discountsSelected);
      }
      return amount;
    },
    calculateDiscountPro(price, items) {
      let percent = 0; //Cantidad que se suma y al final se saca..
      let amount = 0; //Se va sumando;
      items.forEach(e => {
        percent += e.method_discount === "percentage" ? e.discount : 0;
        amount += e.method_discount === "fixed" ? e.discount : 0;
      });
      const totalDiscount = this.percentValue(price, percent) + amount;
      return totalDiscount;
    },
    percentValue(value, percent) {
      return (value * percent) / 100;
    },
    generateItemDiscount(item) {
      return {
        value:
          item.method_discount === "percentage"
            ? `${item.discount}%`
            : `$${item.discount}`,
        title: item.description_method_discount
      };
    },
    generateFinancingAuto() {
      const _guarantee_deposit = this.calculate(
        this.pricingRules.guarantee_deposit
      );
      const _percentage_down_payment = this.calculate(
        this.pricingRules.percentage_down_payment
      );
      const financing_auto =
        this.finalPrice -
        (_guarantee_deposit.value + _percentage_down_payment.value);
      return financing_auto;
    },
    calculate(inputNumber) {
      const { type, amount } = inputNumber;
      if (type === "percentage") {
        return {
          percent: Number(amount),
          value: this.calculateFixed(this.finalPrice, amount)
        };
      }
      return {
        percent: this.calculatePercent(this.finalPrice, amount),
        value: Number(amount)
      };
    },
    // calcular el porcentaje, si el total es 100 y el valor es 30 el resultado es 30%
    calculatePercent(total, value) {
      return (value / total) * 100;
    },
    // calcular el valor, si el total es 100 y el porcentaje es 30% el resultado es 30
    calculateFixed(total, percent) {
      return (total * Number(percent)) / 100;
    },
    formatPrice(number) {
      return FORMATTER.format(number);
    }
  }
};
</script>
